import { Injectable } from '@angular/core';
import { Resource } from '@df/catalog/resource';
import { Store } from '@df/catalog/store/store';

declare module '@df/catalog/resource' {
    interface IResources {
        store: Resource<Store, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class StoreResource extends Resource<Store, number> {
    static override instance = Store;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = false;
}
